/* eslint-disable import/no-unresolved */
import React from "react";
import { Avatar, Box, Typography, useTheme, Button } from "@mui/material";
// import Button from "@mui/material/Button";
import SubHeader from "../../../../../components/SubHeader";
import PurchaseList from "./PurchaseList";
import styles from "./style";
// import {ReactComponent as Contact} from "../../../../../assets/ViewLeave-images/contact.svg"; import {ReactComponent as Pending} from "../../../../../assets/invoice/bi_exclamation.svg";
import { ReactComponent as Question } from "../../../../../assets/invoice/ep_question-filled.svg";
import { ReactComponent as Tick } from "../../../../../assets/invoice/ic_round-check.svg";
import { ReactComponent as Exalamation } from "../../../../../assets/invoice/bi_exclamation.svg";

import { ReactComponent as RTick } from "../../../../../assets/invoice/Vector.svg";
import profile from "../../../../../assets/images/user2.png";

import Grid from "@mui/material/Grid";
import { useNavigate } from "react-router-dom";


const PurchasePage = ({ data, handleSearch, count, page, setPage }) => {
  const navigate = useNavigate()
  const handleAlert = () => {
    navigate("/dashboard/addPurchase")
  }

  const theme = useTheme();
  // const navigate = useNavigate()

  // const handleNavigate = (item) => {
  //   navigate("/dashboard/editPurchase", { state: { item } })
  // }

  // const {showAlert} = useAlert();
  //   const {showAlert} = useAlert();
  //   const [fromDate,setFromDate] = useState(dayjs());
  //   const [toDate,setToDate] = useState(dayjs());
  //   const [leaveType,setLeaveType]=useState();

  //   const [reason,setReason]=useState();
  //   const applyRequest = () =>{
  //     const days = toDate.diff(fromDate, "days");
  //     const tz = moment.tz.guess();
  //     handleLeaveApply(leaveType,fromDate,toDate,days,tz);
  //   }
  const handleText = (text) => {
    handleSearch(text)
  }
  const handleSort = (sort) => {
    handleSearch("", sort)
  }
  return (
    <>
      <Box px="15px" pt="20px">
        <Typography sx={styles.leaveHeading}>Purchase</Typography>
      </Box>
      <Grid container sx={styles.gridContainer}>
        <Grid item xs={12} lg={3.2} sx={styles.StatBoxfirst}>
          <Box width="100%" m="0 10px"   >
            <Box sx={styles.cardBox}>
              <Box sx={styles.iconSection}>
                <Tick style={styles.dollarIcon} />
              </Box>
              <Box sx={{ alignItems: "center" }}>
                <Typography sx={styles.monthlyHeading}>982</Typography>
                <Typography sx={styles.monthlyText}>Invoice Sent</Typography>

              </Box>
            </Box>

          </Box>
        </Grid>
        <Grid item xs={12} lg={3.2} sx={styles.StatBoxfirst}>
          <Box width="100%" m="0 10px"   >
            <Box sx={styles.cardBox}>
              <Box sx={styles.QiconSection}>
                <Question />
              </Box>
              <Box sx={{ alignItems: "center" }}>
                <Typography sx={styles.monthlyHeading}>45</Typography>
                <Typography sx={styles.monthlyText}>Pending Invoice</Typography>

              </Box>
            </Box>

          </Box>
        </Grid>
        <Grid item xs={12} lg={5} sx={styles.StatBox}>
          <Typography sx={styles.totalText}>Total balance</Typography>
          <Typography sx={styles.totalCount}>$4811,21</Typography>


        </Grid>

      </Grid>
      <Grid container sx={styles.gridContainer}>
        <Grid item xs={12} lg={3.2} sx={styles.StatBoxfirst}>
          <Box width="100%" m="0 10px"   >
            <Box sx={styles.cardBox}>
              <Box sx={styles.TiconSection}>
                <RTick style={styles.dollarIcon} />
              </Box>
              <Box sx={{ alignItems: "center" }}>
                <Typography sx={styles.monthlyHeading}>73</Typography>
                <Typography sx={styles.monthlyText}>Paid Voice</Typography>

              </Box>
            </Box>

          </Box>
        </Grid>
        <Grid item xs={12} lg={3.2} sx={styles.StatBoxfirst}>
          <Box width="100%" m="0 10px"   >
            <Box sx={styles.cardBox}>
              <Box sx={styles.EiconSection}>
                <Exalamation />
              </Box>
              <Box sx={{ alignItems: "center" }}>
                <Typography sx={styles.monthlyHeading}>168</Typography>
                <Typography sx={styles.monthlyText}>Unpaid Invoice</Typography>

              </Box>
            </Box>

          </Box>
        </Grid>
        <Grid item xs={12} lg={5} sx={styles.invoiceBox}>
          <Typography sx={styles.invoiceText}>Last Invoice</Typography>
          <Box sx={styles.profileSection}>
            <Box sx={styles.profileGrid}>
              <Avatar src={profile} sx={styles.avatar}></Avatar>
              <Typography sx={styles.userName}>Barry Leo</Typography>
            </Box>
            <Box sx={styles.cardSubtitle}>2 days ago</Box>
          </Box>

        </Grid>

      </Grid>
      <Box sx={styles.gridText}>
        <Box>
          <Typography sx={styles.invoiceHeading}>PurchaseList</Typography>
        </Box>
        <Button variant="contained" color="success" sx={styles.checkoutBtn} onClick={() => handleAlert()}>+ Create Purchase
        </Button>

      </Box>

      <Box sx={{ backgroundColor: theme.palette.white.main, m: 2, borderRadius: "20px" }} >
        <SubHeader
          search={true}
          sortBy={true}
          //   BtnText={"Add Leave Request"}
          onchange={handleText}
          handleSort={handleSort}
        />
        <PurchaseList data={data} count={count} page={page} setPage={setPage}/>

        {/* <Modal open={open} disabled={!leaveType ||!fromDate || !toDate } setOpen={setOpen} btnText={"Apply"} title={"Leave Request"} handleCheck={applyRequest}>
          <Box>
            <InputLabel sx={styles.label}>Leave Status</InputLabel>
            <Select
              value={leaveType}
              onChange={(e) => setLeaveType(e.target.value)}
              name="leaveType"
              // label="LeaveType"

              sx={styles.dropdown}
            >
              <MenuItem value="Half Day">Half Day</MenuItem>
              <MenuItem value="Leave">Leave</MenuItem>
              <MenuItem value="Present">Present</MenuItem>
            </Select>
          </Box>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DemoContainer components={["DatePicker", "DatePicker"]} sx={styles.calender}>
              <Box>
                <InputLabel sx={styles.label}>From</InputLabel>
                <DatePicker  value={fromDate}   minDate={dayjs()} onChange={(newValue) => {setFromDate(newValue) }}  sx={styles.calenderInput} />
              </Box>  
              <Box>
                <InputLabel sx={styles.label}>To</InputLabel>
                <DatePicker
                  // label="To"
                  value={toDate}
                  minDate={fromDate}
                  sx={styles.calenderInput}
                  onChange={(newValue) => {setToDate(newValue);}}
                />
              </Box>            
            </DemoContainer>
          </LocalizationProvider>
          <Box sx={{my:1}}>
            <InputLabel sx={styles.label}>Reason</InputLabel>
            <TextField
              label={"Reason"}
              multiline={true}
              value={reason}
              onChange={(e) => setReason(e.target.value)}
              rows={2}
              sx= {styles.reason}
            />
          </Box>
        </Modal> */}

      </Box>
    </>
  );
};

export default PurchasePage;
